import { INBOX_TYPES } from 'dashboard/helper/inbox';

export const assistantsList = [
  {
    account_id: 2,
    config: { product_name: 'HelpDesk Pro' },
    created_at: 1736033561,
    description:
      'Avançada IA para auxliar no suporte pedagógico',
    id: 4,
    name: 'Suporte Pedagógico',
  },
  {
    account_id: 3,
    config: { product_name: 'CRM Tools' },
    created_at: 1736033562,
    description:
      'IA para otimizar o gerenciamento de relacionamento com clientes',
    id: 5,
    name: 'Assistente CRM',
  },
  {
    account_id: 4,
    config: { product_name: 'SalesFlow' },
    created_at: 1736033563,
    description:
      'Força de Vendas',
    id: 6,
    name: 'Matriculador',
  },
  {
    account_id: 5,
    config: { product_name: 'TicketMaster AI' },
    created_at: 1736033564,
    description:
      'Automates ticket assignment, categorization, and customer query responses to enhance support efficiency.',
    id: 7,
    name: 'TicketBot',
  },
  {
    account_id: 6,
    config: { product_name: 'FinanceAssist' },
    created_at: 1736033565,
    description:
      'Provides financial analytics, reporting, and insights, helping teams make data-driven financial decisions.',
    id: 8,
    name: 'Finance Wizard',
  },
  {
    account_id: 8,
    config: { product_name: 'HR Assistant' },
    created_at: 1736033567,
    description:
      'Streamlines HR operations including employee management, payroll, and recruitment processes.',
    id: 10,
    name: 'HR Helper',
  },
];

export const documentsList = [
  {
    account_id: 1,
    assistant: { id: 1, name: 'Helper Pro' },
    content:
      'Manual de atendimento dos serviços pedagógicos.',
    created_at: 1736143272,
    external_link:
      'https://www.virtuacrm.com/hc/user-guide/articles/1677688192-how-to-use-conversation-filters',
    id: 3059,
    name: 'Manual de atendimento pedagógico',
    status: 'available',
  },
  {
    account_id: 2,
    assistant: { id: 2, name: 'Support Genie' },
    content:
      'Manual de atendimento para realização de matrículas.',
    created_at: 1736143273,
    external_link:
      'https://www.virtuacrm.com/hc/user-guide/articles/1677688200-automating-ticket-assignments',
    id: 3060,
    name: 'Manual de atendimento para novas matrículas',
    status: 'available',
  },
  {
    account_id: 3,
    assistant: { id: 3, name: 'CRM Assistant' },
    content:
      'Manual de atendimento para cobranças',
    created_at: 1736143274,
    external_link:
      'https://www.virtuacrm.com/hc/user-guide/articles/1677688210-managing-customer-profiles',
    id: 3061,
    name: 'Manual de atendimento para cobranças',
    status: 'available',
  },
  {
    account_id: 4,
    assistant: { id: 4, name: 'SalesBot' },
    content:
      'Learn how to optimize sales tracking and improve your sales forecasting using advanced features.',
    created_at: 1736143275,
    external_link:
      'https://www.virtuacrm.com/hc/user-guide/articles/1677688220-sales-tracking-guide',
    id: 3062,
    name: 'Sales Tracking Guide | User Guide | VirtuaCRM',
    status: 'available',
  },
  {
    account_id: 5,
    assistant: { id: 5, name: 'TicketBot' },
    content:
      'How to efficiently create, manage, and resolve tickets in VirtuaCRM.',
    created_at: 1736143276,
    external_link:
      'https://www.virtuacrm.com/hc/user-guide/articles/1677688230-managing-tickets',
    id: 3063,
    name: 'Managing Tickets | User Guide | VirtuaCRM',
    status: 'available',
  },
  {
    account_id: 6,
    assistant: { id: 6, name: 'Finance Wizard' },
    content:
      'Detailed guide on how to use financial reporting tools and generate insightful analytics.',
    created_at: 1736143277,
    external_link:
      'https://www.virtuacrm.com/hc/user-guide/articles/1677688240-financial-reporting',
    id: 3064,
    name: 'Financial Reporting | User Guide | VirtuaCRM',
    status: 'available',
  },
];

export const responsesList = [
  {
    account_id: 1,
    answer:
      'Assista o vídeo explicativo de como você pode *baixar seus livros digitais pelo Studeo*. https://www.youtube.com/watch?v=w81o0H0ae5M&list=PLhV6meBa8y2ubU_5KQXY5SLl77Nm-bYYN&index=3',
    created_at: 1736283330,
    id: 87,
    question: 'Como baixar os livros no Studeo?',
    status: 'pending',
    assistant: {
      account_id: 1,
      config: { product_name: 'VirtuaCRM' },
      created_at: 1736033280,
      description: 'Assistente Geral de Suporte',
      id: 1,
      name: 'Assistant 2',
    },
  },
  {
    account_id: 2,
    answer:
      'Assista o vídeo explicativo de *como você abre um SAE no seu Studeo*. https://www.youtube.com/watch?v=1PgW4tpl7qw&list=PLhV6meBa8y2ubU_5KQXY5SLl77Nm-bYYN&index=5',
    created_at: 1736283340,
    id: 88,
    question: 'Como abrir um SAE ?',
    assistant: {
      account_id: 2,
      config: { product_name: 'VirtuaCRM' },
      created_at: 1736033281,
      description: 'Ajuda com abertura de SAE e suporte técnico.',
      id: 2,
      name: 'Assistant 3',
    },
  },
  {
    account_id: 3,
    answer:
      "To reset your password, go to the login page and click on 'Forgot Password', then follow the instructions sent to your email.",
    created_at: 1736283350,
    id: 89,
    question: 'How can I reset my password in VirtuaCRM?',
    assistant: {
      account_id: 3,
      config: { product_name: 'VirtuaCRM' },
      created_at: 1736033282,
      description: 'Handles account management and recovery support.',
      id: 3,
      name: 'Assistant 4',
    },
  },
  {
    account_id: 4,
    answer:
      "You can enable the dark mode in settings by navigating to 'Appearance' and selecting 'Dark Mode'.",
    created_at: 1736283360,
    id: 90,
    question: 'How do I enable dark mode in VirtuaCRM?',
    assistant: {
      account_id: 4,
      config: { product_name: 'VirtuaCRM' },
      created_at: 1736033283,
      description: 'Helps with UI and theme-related inquiries.',
      id: 4,
      name: 'Assistant 5',
    },
  },
  {
    account_id: 5,
    answer:
      "To add a new team member, navigate to 'Settings', then 'Team', and click on 'Add Team Member'.",
    created_at: 1736283370,
    id: 91,
    question: 'How do I add a new team member in VirtuaCRM?',
    assistant: {
      account_id: 5,
      config: { product_name: 'VirtuaCRM' },
      created_at: 1736033284,
      description: 'Supports team management and user access-related queries.',
      id: 5,
      name: 'Assistant 6',
    },
  },
  {
    account_id: 6,
    answer:
      "Campaigns in VirtuaCRM allow you to send targeted messages to specific user segments. You can create them in the 'Campaigns' section.",
    created_at: 1736283380,
    id: 92,
    question: 'What are campaigns in VirtuaCRM?',
    assistant: {
      account_id: 6,
      config: { product_name: 'VirtuaCRM' },
      created_at: 1736033285,
      description:
        'Specialized in marketing, campaign management, and messaging strategies.',
      id: 6,
      name: 'Assistant 7',
    },
  },
];

export const inboxes = [
  {
    id: 7,
    name: 'Email Support',
    channel_type: INBOX_TYPES.EMAIL,
    email: 'support@company.com',
  },
  {
    id: 1,
    name: 'Website Chat',
    channel_type: INBOX_TYPES.WEB,
  },
  {
    id: 2,
    name: 'Facebook Support',
    channel_type: INBOX_TYPES.FB,
  },
  {
    id: 5,
    name: 'SMS Service',
    channel_type: INBOX_TYPES.TWILIO,
    messaging_service_sid: 'MGxxxxxx',
  },
  {
    id: 6,
    name: 'WhatsApp Support',
    channel_type: INBOX_TYPES.WHATSAPP,
    phone_number: '+1987654321',
  },
  {
    id: 8,
    name: 'Telegram Support',
    channel_type: INBOX_TYPES.TELEGRAM,
  },
  {
    id: 9,
    name: 'LINE Support',
    channel_type: INBOX_TYPES.LINE,
  },
  {
    id: 10,
    name: 'API Channel',
    channel_type: INBOX_TYPES.API,
  },
  {
    id: 11,
    name: 'SMS Basic',
    channel_type: INBOX_TYPES.SMS,
    phone_number: '+1555555555',
  },
];
